import { render, staticRenderFns } from "./AnketsConfigsList.vue?vue&type=template&id=51548792&scoped=true"
import script from "./AnketsConfigsList.vue?vue&type=script&lang=js"
export * from "./AnketsConfigsList.vue?vue&type=script&lang=js"
import style0 from "./AnketsConfigsList.vue?vue&type=style&index=0&id=51548792&prod&lang=scss"
import style1 from "./AnketsConfigsList.vue?vue&type=style&index=1&id=51548792&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51548792",
  null
  
)

export default component.exports